export const removeDuplicates = (arr: Array<any>) => {
    const seen = new Set();
    return arr.filter((item) => {
        const serialized = JSON.stringify(item);
        if (seen.has(serialized)) {
            return false;
        } else {
            seen.add(serialized);
            return true;
        }
    });
}